import { withSvgIconSimple } from './withSvgIconSimple';

export const Rename = withSvgIconSimple(
  <>
    <path d="M18 4V20" stroke="currentColor" strokeWidth="2" />
    <path
      d="M6.75 18H4.5L8.59659 6.36365H11.1989L15.3011 18H13.0511L9.94318 8.75001H9.85227L6.75 18ZM6.82386 13.4375H12.9602V15.1307H6.82386V13.4375Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
